import React, { useEffect, useState, useRef } from 'react';

const Checkbox = ({
  name,
  updateValueToFilters,
  filterType,
  filterValue,
  appliedFilters,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const isPresent =
      appliedFilters &&
      appliedFilters.find(each => each.name === filterType.attr);
    if (isPresent) {
      let check = appliedFilters.find(each => each.value === filterValue.value);
      if (check !== undefined) setIsChecked(true);
      else setIsChecked(false);
    } else {
      setIsChecked(false);
    }
  }, [appliedFilters]);

  const checkRef = useRef();

  return (
    <input
      type="checkbox"
      name={name}
      ref={checkRef}
      checked={isChecked}
      onChange={() => {
        updateValueToFilters(
          filterType.name,
          filterType.attr,
          filterValue.value,
          isChecked
        );
      }}
    />
  );
};

export default Checkbox;
